import type { Card as CardType } from '../game/types';

type Props = {
  card: CardType;
  onClick: () => void;
};

export function Card({ card, onClick }: Props) {
  return (
    <div
      className={`relative aspect-square cursor-pointer perspective-1000 group ${
        card.isMatched ? 'invisible pointer-events-none' : ''
      }`}
      onClick={onClick}
    >
      <div
        className={`w-full h-full duration-500 transform-style-3d transition-transform relative ${
          card.isFlipped ? 'rotate-y-180' : 'hover:scale-105'
        }`}
      >
        <div
          className={`absolute w-full h-full backface-hidden bg-gradient-to-br from-green-400 to-green-600 rounded-xl border-b-4 border-r-4 border-green-800 shadow-md flex items-center justify-center z-10 transition-opacity duration-300 ${
            card.isFlipped ? 'opacity-0' : 'opacity-100'
          }`}
        >
          <span className="text-4xl opacity-80 animate-float">🌱</span>
        </div>
        <div
          className={`absolute w-full h-full backface-hidden rotate-y-180 bg-white rounded-xl border-b-4 border-gray-200 shadow-md flex items-center justify-center p-2 text-center font-bold text-gray-800 break-words overflow-hidden text-sm sm:text-lg transition-opacity duration-300 ${
            card.isFlipped ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {card.content}
        </div>
      </div>
    </div>
  );
}
